import React, { useEffect, useRef } from "react";

import { is_str } from "@components/Utils";
import { VideoFormat, VideoQuality, registerPlayerWebComponent } from "@vkontakte/videoplayer/es2015.esm.js";

const CUSTOM_ELEM = "vk-video-player";

const addConditionalSourcePair = (key, value) => {
    if (!is_str(key)) {
        return {};
    }

    return {
        ...(value && {
            [key]: {
                type: "url",
                url: value,
            },
        }),
    };
};

function VkVideoPlayer(props) {
    const { data, active, noTitle, width, height, className } = props;
    const container = useRef();

    const sources = {
        [VideoFormat.MPEG]: {
            ...addConditionalSourcePair(VideoQuality.Q_144P, data.videos.url_tiny),
            ...addConditionalSourcePair(VideoQuality.Q_240P, data.videos.url_lowest),
            ...addConditionalSourcePair(VideoQuality.Q_360P, data.videos.url_low),
            ...addConditionalSourcePair(VideoQuality.Q_480P, data.videos.url_medium),
            ...addConditionalSourcePair(VideoQuality.Q_720P, data.videos.url_high),
            ...addConditionalSourcePair(VideoQuality.Q_1080P, data.videos.url_fullhd),
            ...addConditionalSourcePair(VideoQuality.Q_1440P, data.videos.url_ultrahd),
            ...addConditionalSourcePair(VideoQuality.Q_2160P, data.videos.url_quadhd),
        },
        ...addConditionalSourcePair(VideoFormat.DASH_SEP, data.videos.url_dash),
        ...addConditionalSourcePair(VideoFormat.HLS, data.videos.url_hls),
        ...addConditionalSourcePair(VideoFormat.DASH_LIVE, data.videos.url_live_playback_dash),
        ...addConditionalSourcePair(VideoFormat.HLS_LIVE, data.videos.url_live_playback_hls),
    };

    const videoConfig = {
        videoId: data.video_id,
        thumbUrl: data.thumbs.url_standard || data.thumbs.url_high || data.thumbs.url_medium,
        sources,
        ...(!noTitle && {
            title: data.title,
        }),
    };

    let player = null;

    useEffect(() => {
        const hasVideoCustomElem = window.customElements?.get(CUSTOM_ELEM);

        if (!hasVideoCustomElem) {
            registerPlayerWebComponent();
        }

        player = document.createElement("vk-video-player");
        container.current.appendChild(player);

        player.initPlayer({
            videos: [videoConfig],
            logoHidden: true,
        });
    }, []);

    useEffect(() => {
        if (!active && player) {
            player.stop();
            player.seekTime(0);
        }
    }, [active]);

    return (
        <div
            ref={container}
            style={{
                width: width ? `${width}px` : "100%",
                height: height ? `${height}px` : "100%",
            }}
            className={className}
        />
    );
}

export default VkVideoPlayer;
